export default "__VITE_ASSET__DiXMjnnm__"